
const Footer = () => {

	return (
		<footer className="footer" style={{ 
            display: "flex",
            justifyContent: "center",
			'--bulma-footer-padding': '0.2rem 1.5rem 3rem' }}>
            <section>
            <div>© Copyright 2024 Julie Dedieu - All Rights Reserved</div>
            </section>
		</footer>
	);
};

export default Footer;